import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { connect, ConnectedProps } from 'react-redux';
import {
  restrictToLawyer,
  search,
  updateLawyerFilter,
} from '../../../../state/actions';
import { StateType } from '../../../../../state/reducers';

const mapState = ({ queryParams }: StateType) => ({
  originalQueryKey: queryParams.originalQueryKey,
  isFilterToggled: !!queryParams.lid,
});

const mapDispatch = (dispatch: ThunkDispatch<StateType, {}, AnyAction>) => ({
  onRestrictToLawyer(data: {
    lawyerId: string;
    lawyerName: string;
    juridiction?: string;
    ville?: string;
  }) {
    dispatch(restrictToLawyer(data));
    dispatch(search({ reason: 'restrict-from-snippet' }));
  },
  toggleLawyerFilter(lawyerId: string | undefined) {
    dispatch(updateLawyerFilter(lawyerId));
    dispatch(search({ reason: 'lawyerFilter' }));
  },
});

export const Connect = connect(mapState, mapDispatch);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
